export const registrationRoute = {
  REGISTRATION_LIST: '/registration/list',
  REGISTRATION_DETAIL: '/registration/detail/:recordId',
  REGISTRATION_SETTING: '/setting/registration'
};
